var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M621.97 198.141H588.19V210.182H621.97V198.141Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03997 447.013H849.582V569.437L776.873 520.964L671.228 566.329L564.34 520.964L471.745 607.345L371.693 635.931L327.57 599.266L292.769 546.443L259.832 578.137L186.502 516.614L135.544 524.071L78.37 474.978L4.41797 456.335L5.03997 447.013Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M634.331 197.927H621.757V208.37H634.331V197.927Z",
    fill: "white",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M535.655 361.392H634.011L625.699 371.942H534.913L535.655 361.392Z",
    fill: "white",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M535.735 325.961H571.646V247.426L590.72 223.237V206.294L575.056 202.564L571.22 202.884V225.688L549.375 249.771L539.891 258.616L535.735 325.961Z",
    fill: "white",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M543.328 232.879H558.992H543.328Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M543.328 232.879H558.992",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M506.227 342.649L506.302 325.997L493.719 324.565L490.253 270.765L490.479 217.417H500.124L504.118 212.519L509.845 212.67V211.314L540.06 195.114L543.978 195.039L543.903 214.404C541.546 215.822 541.838 218.255 543.828 219.905V224.426L540.739 226.988L547.822 229.55L544.431 232.112V250.573L541.792 260.423V275.438L535.917 329.464H533.355C532.054 331.915 530.779 331.491 529.512 330.142V324.943H525.745L525.218 325.998V342.5L506.227 342.649Z",
    fill: "white",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M525.253 325.922H506.302V342.537H525.253V325.922Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M536.075 341.322H496.303V382.755H536.075V341.322Z",
    fill: "white",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M527.22 375.764C527.22 381.942 522.212 386.95 516.034 386.95C509.856 386.95 504.848 381.942 504.848 375.764C504.848 369.586 509.856 364.578 516.034 364.578C522.212 364.578 527.22 369.586 527.22 375.764Z",
    fill: "white",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M523.18 376.385C523.18 380.16 520.119 383.221 516.344 383.221C512.569 383.221 509.508 380.16 509.508 376.385C509.508 372.61 512.569 369.549 516.344 369.549C520.119 369.549 523.18 372.61 523.18 376.385Z",
    fill: "white",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M545.863 382.677H487.292V403.262H545.863V382.677Z",
    fill: "white",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M488.846 403.107V405.748L499.1 410.564V419.264L488.069 433.246H547.106L533.9 418.643V410.564L544.476 405.528L544.631 403.016L488.846 403.107Z",
    fill: "white",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M507.288 432.958V415.247C508.27 406.306 524.29 406.442 526.087 415.247V433.114L507.288 432.958Z",
    fill: "white",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M487.137 392.232H545.863H487.137Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M487.137 392.232H545.863",
    stroke: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M518.451 375.208C518.451 376.323 517.547 377.228 516.431 377.228C515.316 377.228 514.411 376.324 514.411 375.208C514.411 374.093 515.315 373.188 516.431 373.188C517.547 373.189 518.451 374.093 518.451 375.208Z",
    fill: "white",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M559.803 433.502H474.355V446.242H559.803V433.502Z",
    fill: "white",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M492.793 403.109H490.089V405.75H492.793V403.109Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.9341
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M501.796 403.107H498.067V405.748H501.796V403.107Z",
    fill: "white",
    stroke: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M543.245 403.069H540.302V405.71H543.245V403.069Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.8884
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M535.92 403.111H532.191V405.752H535.92V403.111Z",
    fill: "white",
    stroke: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M525.521 403.011H520.913V405.652H525.521V403.011Z",
    fill: "white",
    stroke: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M513.929 403.13H509.431V405.771H513.929V403.13Z",
    fill: "white",
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M496.077 348.779H536.394H496.077Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M496.077 348.779H536.394",
    stroke: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M520.834 418.419C520.834 420.65 519.025 422.458 516.795 422.458C514.564 422.458 512.756 420.649 512.756 418.419C512.756 416.188 514.565 414.38 516.795 414.38C519.026 414.379 520.834 416.188 520.834 418.419Z",
    fill: "white",
    stroke: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M535.096 648.388L571.7 652.331L534.617 655.102L535.096 648.388Z",
    fill: "white",
    stroke: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M534.776 669.487L571.38 665.544L534.297 662.773L534.776 669.487Z",
    fill: "white",
    stroke: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M537.786 447.067H495.801V744.159H537.786V447.067Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M514.769 515.906V534.661L519.245 531.89V515.48L514.769 515.906Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M512.638 510.791V517.185H520.737V506.529L512.638 510.791Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M507.31 446.428V517.398L525.852 506.529V446.642L507.31 446.428Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M498.812 669.22L462.208 665.277L499.291 662.506L498.812 669.22Z",
    fill: "white",
    stroke: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M498.492 648.121L461.888 652.064L498.971 654.835L498.492 648.121Z",
    fill: "white",
    stroke: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M496.744 622.563H536.924L536.887 700.885L496.794 700.992L496.744 622.563Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M507.949 462.625H526.278C527.455 462.625 528.409 463.579 528.409 464.756V478.396C528.409 479.573 527.455 480.527 526.278 480.527H507.949C506.772 480.527 505.818 479.573 505.818 478.396V464.756C505.818 463.579 506.772 462.625 507.949 462.625Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M509.867 578.35V673.829L506.883 675.747V691.518H526.064V675.747L523.08 673.616V575.793L509.867 578.35Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M507.31 581.121L507.523 536.792L526.043 526.099V577.285L507.31 581.121Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M507.31 546.382H525.852C527.029 546.382 527.983 547.336 527.983 548.513V559.808C527.983 560.985 527.029 561.939 525.852 561.939H507.31C506.133 561.939 505.179 560.985 505.179 559.808V548.513C505.179 547.336 506.133 546.382 507.31 546.382Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M510.16 583.039L511.395 583.87L510.16 583.039Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M510.16 583.039L511.395 583.87",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M510.209 595.118L511.444 595.949L510.209 595.118Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M510.209 595.118L511.444 595.949",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 589.071L511.391 589.902L510.156 589.071Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 589.071L511.391 589.902",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M510.196 601.139L511.431 601.97L510.196 601.139Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M510.196 601.139L511.431 601.97",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M510.169 607.159L511.404 607.99L510.169 607.159Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M510.169 607.159L511.404 607.99",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 613.193L511.391 614.024L510.156 613.193Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 613.193L511.391 614.024",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M510.182 619.227L511.417 620.058L510.182 619.227Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M510.182 619.227L511.417 620.058",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 625.221L511.391 626.052L510.156 625.221Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 625.221L511.391 626.052",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 631.322L511.391 632.153L510.156 631.322Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 631.322L511.391 632.153",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M510.182 637.316L511.417 638.147L510.182 637.316Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M510.182 637.316L511.417 638.147",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 643.363L511.391 644.194L510.156 643.363Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 643.363L511.391 644.194",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 649.331L511.391 650.162L510.156 649.331Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 649.331L511.391 650.162",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 655.378L511.391 656.209L510.156 655.378Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 655.378L511.391 656.209",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 661.399L511.391 662.23L510.156 661.399Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 661.399L511.391 662.23",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 667.446L511.391 668.277L510.156 667.446Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M510.156 667.446L511.391 668.277",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M522.761 586.06L521.526 586.891L522.761 586.06Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M522.761 586.06L521.526 586.891",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M522.713 598.139L521.478 598.97L522.713 598.139Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M522.713 598.139L521.478 598.97",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 592.092L521.531 592.923L522.766 592.092Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 592.092L521.531 592.923",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M522.726 604.16L521.491 604.991L522.726 604.16Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M522.726 604.16L521.491 604.991",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M522.753 610.18L521.518 611.011L522.753 610.18Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M522.753 610.18L521.518 611.011",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 616.214L521.531 617.045L522.766 616.214Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 616.214L521.531 617.045",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M522.739 622.248L521.504 623.079L522.739 622.248Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M522.739 622.248L521.504 623.079",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 628.242L521.531 629.073L522.766 628.242Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 628.242L521.531 629.073",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 634.343L521.531 635.174L522.766 634.343Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 634.343L521.531 635.174",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M522.739 640.337L521.504 641.168L522.739 640.337Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M522.739 640.337L521.504 641.168",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 646.384L521.531 647.215L522.766 646.384Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 646.384L521.531 647.215",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 652.352L521.531 653.183L522.766 652.352Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 652.352L521.531 653.183",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 658.399L521.531 659.23L522.766 658.399Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 658.399L521.531 659.23",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 664.42L521.531 665.251L522.766 664.42Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 664.42L521.531 665.251",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 670.467L521.531 671.298L522.766 670.467Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 670.467L521.531 671.298",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 580.066L521.531 580.897L522.766 580.066Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M522.766 580.066L521.531 580.897",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M509.037 696.232L496.877 700.614L496.942 718.343L508.504 723.192L523.316 722.446L536.796 718.237L536.903 700.601L521.825 696.019L509.037 696.232Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M526.118 691.465H506.752V725.884H526.118V691.465Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M507.31 726.151L509.974 740.377L522.815 740.484L525.586 726.045L507.31 726.151Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M540.13 741.069H494.309V745.118H540.13V741.069Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M571.346 358.651H564.715V374.248H571.346V358.651Z",
    fill: "white",
    stroke: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M587.998 359.027V374.323H618.213L618.194 359.027H587.998Z",
    fill: "white",
    stroke: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M564.832 361.732C564.653 365.082 564.317 368.424 564.832 371.675V361.732Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M564.832 361.732C564.653 365.082 564.317 368.424 564.832 371.675",
    stroke: "black",
    strokeWidth: 1.5415
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M571.483 361.71C571.304 365.081 570.968 368.445 571.483 371.717V361.71Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M571.483 361.71C571.304 365.081 570.968 368.445 571.483 371.717",
    stroke: "black",
    strokeWidth: 1.5465
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M588.135 361.634C587.956 365.005 587.62 368.369 588.135 371.641V361.634Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M588.135 361.634C587.956 365.005 587.62 368.369 588.135 371.641",
    stroke: "black",
    strokeWidth: 1.5465
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M618.35 361.634C618.171 365.005 617.835 368.369 618.35 371.641V361.634Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M618.35 361.634C618.171 365.005 617.835 368.369 618.35 371.641",
    stroke: "black",
    strokeWidth: 1.5465
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M601.913 360.718V356.404H607.128V360.718H601.913Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M611.249 350.384C611.256 354.118 608.234 357.15 604.5 357.156C600.766 357.163 597.734 354.141 597.728 350.407C597.728 350.399 597.728 350.391 597.728 350.383C597.721 346.649 600.743 343.617 604.477 343.611C608.211 343.604 611.243 346.626 611.249 350.36C611.249 350.368 611.249 350.376 611.249 350.384Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2084,
    strokeMiterlimit: 4.8337
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M598.699 353.446L600.437 352.706L598.699 353.446Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M598.699 353.446L600.437 352.706",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M597.862 351L599.633 350.903L597.862 351Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M597.862 351L599.633 350.903",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M598.216 348.199L599.794 348.746L598.216 348.199Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M598.216 348.199L599.794 348.746",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M599.697 345.72L600.888 346.879L599.697 345.72Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M599.697 345.72L600.888 346.879",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M603.418 350.337L608.722 346.112L609.795 347.524L604.44 351.497L603.418 350.337Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M601.821 344.143L602.497 345.688L601.821 344.143Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M601.821 344.143L602.497 345.688",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M605.648 350.44C605.652 351.027 605.18 351.506 604.593 351.51C604.006 351.514 603.528 351.042 603.523 350.455C603.523 350.45 603.523 350.445 603.523 350.441C603.519 349.854 603.991 349.375 604.578 349.371C605.165 349.367 605.644 349.839 605.648 350.426C605.648 350.43 605.648 350.435 605.648 350.44Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2084,
    strokeMiterlimit: 4.8337
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M604.558 343.66L604.525 345.334L604.558 343.66Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M604.558 343.66L604.525 345.334",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M610.434 353.446L608.696 352.706L610.434 353.446Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M610.434 353.446L608.696 352.706",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M611.271 351L609.5 350.903L611.271 351Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M611.271 351L609.5 350.903",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M610.917 348.199L609.339 348.746L610.917 348.199Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M610.917 348.199L609.339 348.746",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M609.436 345.72L608.245 346.879L609.436 345.72Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M609.436 345.72L608.245 346.879",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M607.311 344.143L606.635 345.688L607.311 344.143Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M607.311 344.143L606.635 345.688",
    stroke: "black",
    strokeWidth: 1.2084
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M611.249 350.384C611.256 354.118 608.234 357.15 604.5 357.156C600.766 357.163 597.734 354.141 597.728 350.407C597.728 350.399 597.728 350.391 597.728 350.383C597.721 346.649 600.743 343.617 604.477 343.611C608.211 343.604 611.243 346.626 611.249 350.36C611.249 350.368 611.249 350.376 611.249 350.384Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2084,
    strokeMiterlimit: 4.8337
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M503.062 337.337C503.062 338.211 502.354 338.919 501.48 338.919C500.606 338.919 499.898 338.211 499.898 337.337C499.898 336.463 500.606 335.755 501.48 335.755C502.354 335.755 503.062 336.463 503.062 337.337Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M504.344 337.638H498.617V340.953H504.344V337.638Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M512.142 337.356C512.142 338.23 511.434 338.938 510.56 338.938C509.686 338.938 508.978 338.23 508.978 337.356C508.978 336.482 509.686 335.774 510.56 335.774C511.434 335.774 512.142 336.482 512.142 337.356Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M513.423 337.657H507.696V340.972H513.423V337.657Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M522.689 337.375C522.689 338.249 521.981 338.957 521.107 338.957C520.233 338.957 519.525 338.249 519.525 337.375C519.525 336.501 520.233 335.793 521.107 335.793C521.981 335.793 522.689 336.501 522.689 337.375Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M523.971 337.676H518.244V340.991H523.971V337.676Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M532.279 337.356C532.279 338.23 531.571 338.938 530.697 338.938C529.823 338.938 529.115 338.23 529.115 337.356C529.115 336.482 529.823 335.774 530.697 335.774C531.571 335.774 532.279 336.482 532.279 337.356Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M533.561 337.657H527.834V340.972H533.561V337.657Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M506.302 325.922H525.441H506.302Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M506.302 325.922H525.441",
    stroke: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M530.264 312.811H500.877L498.466 259.765L497.562 259.614C494.907 257.996 494.893 257.012 497.261 256.6C509.526 255.296 521.666 255.496 533.73 256.6C536.141 257.156 535.919 258.08 533.353 259.689L532.524 259.915L530.264 312.811Z",
    fill: "white",
    stroke: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M498.466 259.764H532.826C535.281 258.32 538.715 256.39 530.679 256.336C520.733 255.798 510.441 255.119 500.2 256.449C493.534 256.304 495.58 258.805 498.466 259.764Z",
    fill: "white",
    stroke: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M504.72 312.588V285.986H526.496V312.737L504.72 312.588Z",
    fill: "white",
    stroke: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M504.795 293.37H526.496H504.795Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M504.795 293.37H526.496",
    stroke: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M513.687 268.879V259.915H518.585V269.685L513.687 268.879Z",
    fill: "white",
    stroke: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M509.392 285.76V272.423V267.224H522.578V285.911L509.392 285.76Z",
    fill: "white",
    stroke: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M509.542 273.101H522.653H509.542Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M509.542 273.101H522.653",
    stroke: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M515.872 211.088V242.81H520.468V210.937L515.872 211.088Z",
    fill: "white",
    stroke: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M498.617 205.889L498.542 210.561H508.564L509.996 211.541H532.6V206.191L498.617 205.889Z",
    fill: "white",
    stroke: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M508.469 208.978L511.031 211.54H522.032L524.481 209.091L508.469 208.978Z",
    fill: "white",
    stroke: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M488.218 197.525V207.547H538.627L538.326 197.299L488.218 197.525Z",
    fill: "white",
    stroke: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M559.605 308.165C559.609 311.049 557.275 313.39 554.391 313.394C551.507 313.398 549.166 311.064 549.162 308.18C549.162 308.175 549.162 308.17 549.162 308.164C549.158 305.28 551.492 302.939 554.376 302.935C557.26 302.931 559.601 305.265 559.605 308.149C559.605 308.154 559.605 308.16 559.605 308.165Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M560.351 279.979H549.428V285.307H560.351V279.979Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M541.436 263.356L552.305 256.003L552.198 246.199L543.46 246.465L540.903 260.052L541.436 263.356Z",
    fill: "white",
    stroke: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M560.191 238.953L557.634 232.932L567.704 224.141L568.901 224.462L568.93 229.096L560.191 238.953Z",
    fill: "white",
    stroke: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M568.556 224.834V209.915H564.08V203.468L573.937 196.914H589.069V208.263H576.335V205.492H571.486L571.246 225.712L568.609 228.616L568.556 224.834Z",
    fill: "white",
    stroke: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M583.741 300.013L587.844 304.382L587.897 311.415L590.721 311.468L590.455 299.32L585.02 295.644L581.13 295.697L583.741 300.013Z",
    fill: "white",
    stroke: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M580.917 296.39V288.771L582.249 287.546L582.089 265.754L583.847 264.369H597.807V257.229H584.274L582.995 255.577L583.102 233.306L584.605 230.702L590.721 230.642L593.172 234.105L593.332 221.637L590.721 219.825L577.361 234.584L576.042 296.483L580.917 296.39Z",
    fill: "white",
    stroke: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M583.568 300.226L583.501 295.537L576.202 295.564L577.427 234.584L572.206 241.297L572.526 259.945L568.903 262.396L568.97 278.687H572.007L572.047 283.895L568.797 283.922L568.69 303.955L571.82 304.008L583.568 300.226Z",
    fill: "white",
    stroke: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M583.608 311.202L595.543 312.587L596.395 224.994L599.485 222.543L599.165 210.182L611.739 209.862L614.083 207.837L621.968 207.944L676.421 221.051L675.142 260.905L673.863 262.184L674.289 296.923L668.961 302.89V306.726L670.932 307.152L670.825 329.157L638.537 340.506H614.188L583.818 328.891L583.608 311.202Z",
    fill: "white",
    stroke: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M608.37 210.249L608.383 330.117L608.37 210.249Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M608.37 210.249L608.383 330.117",
    stroke: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M614.43 208.131L614.403 330.117L614.43 208.131Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M614.43 208.131L614.403 330.117",
    stroke: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M620.478 208.211V330.117V208.211Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M620.478 208.211V330.117",
    stroke: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M626.445 210.075V329.743V210.075Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M626.445 210.075V329.743",
    stroke: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M632.572 210.129V329.797V210.129Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M632.572 210.129V329.797",
    stroke: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M638.54 210.022V329.69V210.022Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M638.54 210.022V329.69",
    stroke: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M644.561 209.809V329.477V209.809Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M644.561 209.809V329.477",
    stroke: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M622.929 221.691V225.634L646.053 225.421V221.372L622.929 221.691Z",
    fill: "white",
    stroke: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M621.65 224.568V251.315H647.225L647.172 224.195L621.65 224.568Z",
    fill: "white",
    stroke: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M626.339 248.331C626.339 249.273 625.576 250.036 624.634 250.036C623.692 250.036 622.929 249.273 622.929 248.331C622.929 247.389 623.692 246.626 624.634 246.626C625.575 246.626 626.339 247.389 626.339 248.331Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M645.946 248.331C645.946 249.273 645.183 250.036 644.241 250.036C643.299 250.036 642.536 249.273 642.536 248.331C642.536 247.389 643.299 246.626 644.241 246.626C645.182 246.626 645.946 247.389 645.946 248.331Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M626.285 227.019C626.285 227.961 625.522 228.724 624.58 228.724C623.638 228.724 622.875 227.961 622.875 227.019C622.875 226.077 623.638 225.314 624.58 225.314C625.522 225.314 626.285 226.077 626.285 227.019Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M646.106 227.178C646.106 228.12 645.343 228.883 644.401 228.883C643.459 228.883 642.696 228.12 642.696 227.178C642.696 226.236 643.459 225.473 644.401 225.473C645.342 225.473 646.106 226.237 646.106 227.178Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M650.635 210.022V329.69V210.022Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M650.635 210.022V329.69",
    stroke: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M656.389 209.702V329.37V209.702Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M656.389 209.702V329.37",
    stroke: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M662.037 209.756V329.424V209.756Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M662.037 209.756V329.424",
    stroke: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M667.578 209.543V329.211V209.543Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M667.578 209.543V329.211",
    stroke: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M672.799 219.4V297.891V219.4Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M672.799 219.4V297.891",
    stroke: "black",
    strokeWidth: 0.997
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M621.863 222.65L621.756 206.453L670.881 208.904C672.376 209.273 673.503 210.102 673.865 211.888V224.675L649.782 222.437L621.863 222.65Z",
    fill: "white",
    stroke: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M602.349 210.408L602.362 330.276L602.349 210.408Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M602.349 210.408L602.362 330.276",
    stroke: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M596.342 274.564V329.717V274.564Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M596.342 274.564V329.717",
    stroke: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M595.329 306.673H668.883H595.329Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M595.329 306.673H668.883",
    stroke: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M590.321 312.311V330.183V312.311Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M590.321 312.311V330.183",
    stroke: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M585.312 311.682V329.046V311.682Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M585.312 311.682V329.046",
    stroke: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M584.131 328.69L670.605 328.941L638.499 340.229L614.26 340.223L584.131 328.69Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M108.363 234.56H103.088V290.168H108.363V234.56Z",
    fill: "white",
    stroke: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4019 291.826H74.0029V295.594H95.4019V291.826Z",
    fill: "white",
    stroke: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6719 353.085C93.7819 360.017 102.522 359.791 104.934 353.236L106.064 348.866",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6719 353.085C93.7819 360.017 102.522 359.791 104.934 353.236L106.064 348.866",
    stroke: "black",
    strokeWidth: 2
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1089 446.67H91.5969L91.6719 351.88L78.1089 351.729V446.67Z",
    fill: "white",
    stroke: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7579 446.821L88.5829 351.88H78.1089V446.746L88.7579 446.821Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.0763
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M95.289 348.64H74.116V352.106H95.289V348.64Z",
    fill: "white",
    stroke: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M110.924 294.84H60.1379V349.243H110.924V294.84Z",
    fill: "white",
    stroke: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M108.664 298.306H62.3989V345.777H108.664V298.306Z",
    fill: "white",
    stroke: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0579 337.394C75.0579 340.755 72.4599 343.479 69.2559 343.479C66.0519 343.479 63.4539 340.755 63.4539 337.394C63.4539 334.033 66.0519 331.309 69.2559 331.309C72.4599 331.309 75.0579 334.034 75.0579 337.394Z",
    fill: "white",
    stroke: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M87.114 337.421C87.114 340.796 84.516 343.532 81.312 343.532C78.108 343.532 75.51 340.796 75.51 337.421C75.51 334.046 78.108 331.31 81.312 331.31C84.516 331.31 87.114 334.045 87.114 337.421Z",
    fill: "white",
    stroke: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1699 337.374C99.1699 340.723 96.5719 343.439 93.3679 343.439C90.1639 343.439 87.5659 340.724 87.5659 337.374C87.5659 334.024 90.1639 331.309 93.3679 331.309C96.5719 331.309 99.1699 334.024 99.1699 337.374Z",
    fill: "white",
    stroke: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M72.819 337.337C72.819 339.18 71.325 340.674 69.482 340.674C67.639 340.674 66.145 339.18 66.145 337.337C66.145 335.494 67.639 334 69.482 334C71.325 334 72.819 335.494 72.819 337.337Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4286,
    strokeMiterlimit: 5.7143
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8749 337.337C84.8749 339.18 83.3809 340.674 81.5379 340.674C79.6949 340.674 78.2009 339.18 78.2009 337.337C78.2009 335.494 79.6949 334 81.5379 334C83.3809 334 84.8749 335.494 84.8749 337.337Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4286,
    strokeMiterlimit: 5.7143
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9308 337.337C96.9308 339.18 95.4368 340.674 93.5938 340.674C91.7508 340.674 90.2568 339.18 90.2568 337.337C90.2568 335.494 91.7508 334 93.5938 334C95.4368 334 96.9308 335.494 96.9308 337.337Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4286,
    strokeMiterlimit: 5.7143
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M65.111 301.923H106.704C107.37 301.923 107.91 302.463 107.91 303.129V327.844C107.91 328.51 107.37 329.05 106.704 329.05H65.111C64.445 329.05 63.905 328.51 63.905 327.844V303.129C63.906 302.462 64.445 301.923 65.111 301.923Z",
    fill: "white",
    stroke: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M106.253 304.786H65.865V326.788H106.253V304.786Z",
    fill: "white",
    stroke: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M102.334 289.867H109.869C110.535 289.867 111.075 290.407 111.075 291.073V293.484C111.075 294.15 110.535 294.69 109.869 294.69H102.334C101.668 294.69 101.128 294.15 101.128 293.484V291.073C101.129 290.406 101.668 289.867 102.334 289.867Z",
    fill: "white",
    stroke: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M103.841 227.175H108.362C109.694 227.175 110.773 228.255 110.773 229.586V232.751C110.773 234.083 109.693 235.162 108.362 235.162H103.841C102.509 235.162 101.43 234.082 101.43 232.751V229.586C101.43 228.255 102.51 227.175 103.841 227.175Z",
    fill: "white",
    stroke: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M101.43 230.642H73.7009H101.43Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M101.43 230.642H73.7009",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M98.115 216.174V244.506V216.174Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M98.115 216.174V244.506",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M94.196 218.661V242.17V218.661Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M94.196 218.661V242.17",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M90.241 221.713V239.27V221.713Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M90.241 221.713V239.27",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3979 225.367V236.933V225.367Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3979 225.367V236.933",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M82.781 227.778V233.467V227.778Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M82.781 227.778V233.467",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5239 228.984V232.45V228.984Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5239 228.984V232.45",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M670.845 198.212V168.939C670.419 167.091 668.792 166.758 667.247 166.321L519.354 166.66V198.307L670.845 198.212Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M442.168 198.472L519.514 198.074L519.448 166.592H444.753C442.21 166.584 441.68 167.648 441.771 169.044L442.168 198.472Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M441.988 198.46L441.775 168.836C441.678 166.773 443.056 166.313 444.439 166.172H667.471C670.154 166.443 671.225 167.77 671.147 169.848V198.46H441.988Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M491.677 166.195V150.421L503.276 147.306H531.775L538.602 150.355V166.262L491.677 166.195Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M504.468 147.439V165.997V147.439Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M504.468 147.439V165.997",
    stroke: "black",
    strokeWidth: 2
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M530.515 147.439V166.129V147.439Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M530.515 147.439V166.129",
    stroke: "black",
    strokeWidth: 2
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M511.096 149.096H522.032C522.471 149.096 522.827 149.482 522.827 149.958V151.416C522.827 151.892 522.471 152.278 522.032 152.278H511.096C510.657 152.278 510.301 151.892 510.301 151.416V149.958C510.301 149.481 510.657 149.096 511.096 149.096Z",
    fill: "white",
    stroke: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M511.129 153.139H522.065C522.504 153.139 522.86 153.525 522.86 154.001V155.459C522.86 155.935 522.504 156.321 522.065 156.321H511.129C510.69 156.321 510.334 155.935 510.334 155.459V154C510.334 153.524 510.69 153.139 511.129 153.139Z",
    fill: "white",
    stroke: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M511.129 157.181H522.065C522.504 157.181 522.86 157.567 522.86 158.043V159.501C522.86 159.977 522.504 160.363 522.065 160.363H511.129C510.69 160.363 510.334 159.977 510.334 159.501V158.043C510.334 157.567 510.69 157.181 511.129 157.181Z",
    fill: "white",
    stroke: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M564.085 204.189V198.274V204.189Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M564.085 204.189V198.274",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcp);
export default __webpack_public_path__ + "static/media/pcp.07baa0908c1fba4bc4adafacf0e1d09a.svg";
export { ForwardRef as ReactComponent };